import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "legend-item" }
const _hoisted_2 = { class: "legend-item__label" }
const _hoisted_3 = { class: "legend-item__value" }

import Badge from "./Badge.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GraphLegendItem',
  props: {
    color: {},
    label: {},
    value: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "ff94a54e": (_ctx.color)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(Badge, {
        color: __props.color,
        class: "legend-item__bullet"
      }, null, 8, ["color"]),
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.value), 1)
    ])
  ]))
}
}

})